<template>
  <b-row>

    <RegionOverview :lgSize="12"></RegionOverview>
<!--    <ChartNormal size="12" offset="0" title="Delivered Per Customer" chart="column" chartType="company" :withDate="true" :withFinancial="false" :isCompanyOverall="true" />-->
    <ChartNormal
        size="6"
        offset="0"
        title="Active Backlog XM1"
        chart="column"
        chartType="backlogXM1"
        :withDate="false"
        :withFinancial="false"
        xlsxUrl="exportBacklog1.php?prodGroup=Meter&xml=true"
        exportName="Active Backlog XM1"
    />
    <ChartNormal
        size="6"
        offset="0"
        title="Active Backlog XM2"
        chart="column"
        chartType="backlogXM2"
        :withDate="false"
        :withFinancial="false"
        xlsxUrl="exportBacklog2.php?prodGroup=Meter&xml=true"
        exportName="Active Backlog XM2"
    />
<!--    <ChartNormal size="6" offset="0" title="Delivered Equipment" chart="pie" chartType="Shipped" :withDate="true" :withFinancial="true" />-->
    <ChartNormal
        size="6"
        offset="0"
        title="Delivered Equipment XM1"
        chart="pie"
        chartType="ShippedXM1"
        :withDate="true"
        :withFinancial="true"
        xlsxUrl="exportShippedXM1.php?prodGroup=Meter&xml=true"
        exportName="Delivered Equipment XM1"
    />
    <ChartNormal
        size="6"
        offset="0"
        title="Delivered Equipment XM2"
        chart="pie"
        chartType="ShippedXM2"
        :withDate="true"
        :withFinancial="true"
        xlsxUrl="exportShippedXM2.php?prodGroup=Meter&xml=true"
        exportName="Delivered Equipment XM2"
    />
<!--    Received Equipment-->
    <ChartNormal
        size="6"
        offset="0"
        title="Received Equipment XM1"
        chart="pie"
        chartType="receivedXM1"
        :withDate="true"
        :withFinancial="true"
        xlsxUrl="exportReceivedXM1.php?prodGroup=Meter&xml=true"
        exportName="Received Equipment XM1"
    />
    <ChartNormal
        size="6"
        offset="0"
        title="Received Equipment XM2"
        chart="pie"
        chartType="receivedXM2"
        :withDate="true"
        :withFinancial="true"
        xlsxUrl="exportReceivedXM2.php?prodGroup=Meter&xml=true"
        exportName="Received Equipment XM2"
    />
    <ChartStacked
        size="6"
        offset="0"
        title="Repair Analytics"
        chartType="repair"
        :withDate="true"
        :withFinancial="false"
    />
    <ChartStacked
        size="6"
        offset="0"
        title="Historical Data"
        chartType="historical"
        :withDate="false"
        :withFinancial="false"
    />

  </b-row>
</template>

<script>
import ChartNormal from "../components/chart/chartNormal";
import ChartStacked from "../components/chart/chartStacked";
import RegionOverview from "../components/RegionOverview";

export default {
  name: "Dashboard",
  components: {
    ChartNormal,
    ChartStacked,
    RegionOverview
  },
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-label {
  color: #00bf8f !important;
  fill: #00bf8f !important;
}
.markan {
  position: relative;
  /*height: 400px;*/
  .map-container {
    height: 100%;
  }
  .btn-map-fullscreen {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 36px;
    height: 36px;
    padding: 0;
    font-size: 36px;
    line-height: 36px;
    text-align: center;
    outline: none;
  }
  &.fullscreen {
    width: 100%;
    height: 100%;
  }
}
.power {
  background-color: #f86c6b !important;
}
</style>


